// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IdcardFilledSvg from "@fishx/icons-svg/es/asn/IdcardFilled";
import FishxIcon from '../components/FishxIcon';

var IdcardFilled = function IdcardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: IdcardFilledSvg
  }));
};

IdcardFilled.displayName = 'IdcardFilled';
export default React.forwardRef(IdcardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/IdcardFilled.js
// module id = 2954
// module chunks = 0